import { LockOpenOutlined } from '@mui/icons-material';
import { ListItemIcon, ListItemText } from '@mui/material';

import type { DocumentType } from '@/gql';
import { graphql } from '@/gql';

import { useMutation } from '@/hooks/mutationWithSnackbar';

import { MaybeUsableMenuItem } from './MaybeUnusableMenuItem';

const UNLOCK_FILE_MUTATION = graphql(`
  mutation UnlockFile($data: UnlockFileInput) {
    unlockFile(params: $data) {
      file {
        ...fileFields
      }
    }
  }
`);

const UNLOCK_FILE_MENU_ITEM_FILE_FRAGMENT = graphql(`
  fragment unlockFileMenuItemFileFields on File {
    ...fileFields
  }
`);

interface Props {
  file: DocumentType<typeof UNLOCK_FILE_MENU_ITEM_FILE_FRAGMENT>;
  canLock: boolean;
  canLockRoot: boolean;
  unusableExplanation: string | null;
  onClose: () => void;
}

export const UnlockFileMenuItem = ({
  file,
  canLock,
  canLockRoot,
  unusableExplanation,
  onClose,
}: Props) => {
  const { _id: fileId } = file;

  const [unlockFile] = useMutation(UNLOCK_FILE_MUTATION, {
    completionMessage: `"${file?.filename}" was unlocked successfully`,
    optimisticResponse: {
      unlockFile: {
        __typename: 'UnlockFileResult',
        file: {
          ...file,
          adminLock: false,
        },
      },
    },
  });

  return (
    <MaybeUsableMenuItem
      isUsable={canLock}
      isExpectedUsable={canLockRoot}
      unusableExplanation={unusableExplanation}
      onClick={() => {
        onClose();
        unlockFile({
          variables: {
            data: {
              file: fileId,
            },
          },
        });
      }}
    >
      <ListItemIcon>
        <LockOpenOutlined />
      </ListItemIcon>
      <ListItemText primary="Unlock" />
    </MaybeUsableMenuItem>
  );
};
